import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=c6148faa"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports